import type React from 'react';

interface ProgressRingProps {
	confirmed: number;
	total: number;
}

const ProgressRing: React.FC<ProgressRingProps> = ({ confirmed, total }) => {
	const percentage = Math.round((confirmed / total) * 100);
	const radius = 48;
	const strokeWidth = 5;
	const normalizedRadius = radius - strokeWidth;
	const circumference = normalizedRadius * 2 * Math.PI;
	const strokeDashoffset = circumference - (confirmed / total) * circumference;

	return (
		<svg
			width={radius * 2}
			height={radius * 2}
			viewBox={`0 0 ${radius * 2} ${radius * 2}`}
			aria-label={`${confirmed} of ${total} requirements confirmed`}
		>
			{/* Track */}
			<circle
				cx={radius}
				cy={radius}
				r={normalizedRadius}
				fill='none'
				stroke='var(--color-border-default)'
				strokeWidth={strokeWidth}
				opacity={0.3}
			/>
			{/* Progress */}
			<circle
				cx={radius}
				cy={radius}
				r={normalizedRadius}
				fill='none'
				stroke='var(--color-success)'
				strokeWidth={strokeWidth}
				strokeLinecap='round'
				strokeDasharray={circumference}
				strokeDashoffset={strokeDashoffset}
				transform={`rotate(-90 ${radius} ${radius})`}
				style={{
					transition: 'stroke-dashoffset 500ms cubic-bezier(0.22, 1, 0.36, 1)',
					filter: confirmed > 0 ? 'drop-shadow(0 0 4px rgba(34, 197, 94, 0.4))' : 'none',
				}}
			/>
			{/* Percentage text */}
			<text
				x={radius}
				y={radius}
				textAnchor='middle'
				dominantBaseline='central'
				style={{
					fontFamily: 'var(--font-family-bold)',
					fontSize: '22px',
					fill: 'var(--color-text-primary)',
				}}
			>
				{percentage}%
			</text>
		</svg>
	);
};

export default ProgressRing;
